export class VotingFacade {
    constructor(sdk) { this.sdk = sdk; }
    async contestedResourceVoteState(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getContestedResourceVoteState(query);
    }
    async contestedResourceVoteStateWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getContestedResourceVoteStateWithProofInfo(query);
    }
    async contestedResourceIdentityVotes(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getContestedResourceIdentityVotes(query);
    }
    async contestedResourceIdentityVotesWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getContestedResourceIdentityVotesWithProofInfo(query);
    }
    async votePollsByEndDate(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getVotePollsByEndDate(query ?? null);
    }
    async votePollsByEndDateWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getVotePollsByEndDateWithProofInfo(query ?? null);
    }
    async masternodeVote(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.masternodeVote(options);
    }
}
